module.exports = __webpack_public_path__ + "static/media/fu-exercise2.251198fc.png";